import React, { useState } from 'react';
import Wallet from './assets/wallet2.png';
import Logo from './assets/logofull.png';

// SVG Icons
const MenuIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="12" x2="20" y2="12"></line>
    <line x1="4" y1="6" x2="20" y2="6"></line>
    <line x1="4" y1="18" x2="20" y2="18"></line>
  </svg>
);

const SecurityIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </svg>
);

const ExchangeIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 3 21 3 21 8"></polyline>
    <line x1="4" y1="20" x2="21" y2="3"></line>
    <polyline points="8 21 3 21 3 16"></polyline>
    <line x1="21" y1="21" x2="16" y2="21"></line>
    <line x1="16" y1="21" x2="16" y2="16"></line>
  </svg>
);

const FeeIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23"></line>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
  </svg>
);

const DownloadIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const AndroidIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 12h10M7 8h10M7 16h4"/>
    <rect x="3" y="5" width="18" height="14" rx="2" ry="2"/>
  </svg>
);

const EmailIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

// Components
const PromotionBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 w-full z-30 bg-gradient-to-r from-violet-600 via-purple-600 to-blue-600 shadow-lg border-b border-violet-400/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center py-3 relative">
          <a 
            href="https://p2proad.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white font-bold text-sm sm:text-base hover:text-violet-200 transition-colors duration-200 flex items-center"
          >
            <span className="mr-2">🎉</span>
            <span>Visit</span>
            <span className="mx-1 font-extrabold text-lg sm:text-xl underline decoration-2 underline-offset-2">p2proad.com</span>
            <span className="ml-1 hidden sm:inline">for amazing deals!</span>
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </a>
          <button
            onClick={() => setIsVisible(false)}
            className="absolute right-4 text-white hover:text-violet-200 transition-colors duration-200 p-1"
            aria-label="Close banner"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

const NavBar = () => {
  return (
    <header className="fixed top-12 left-0 w-full z-20 bg-gray-900/80 backdrop-blur-sm shadow-xl border-b border-blue-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex-shrink-0 flex items-center">
            <img 
              src={Logo}
              alt="Moon Wallet Logo" 
              className="h-8 w-auto mr-2" 
            />
            <span className="text-3xl font-extrabold text-white">
              <span className="text-white">Moon</span>
              <span className="text-violet-400">Wallet</span>
            </span>
          </div>
          <div className="hidden md:flex items-center">
            <a 
              href="mailto:info@moonwallet.io"
              className="flex items-center text-gray-300 hover:text-violet-400 transition-colors duration-200 text-sm font-medium"
            >
              <EmailIcon className="w-4 h-4 mr-2" />
              <span className="hidden lg:inline">info@moonwallet.io</span>
              <span className="lg:hidden">Contact</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

const HeroSection = () => {
  const scrollToDownload = () => {
    document.getElementById('download-section')?.scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  return (
    <section className="relative pt-48 pb-24 lg:pt-64 lg:pb-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="lg:flex lg:items-center">
          <div className="lg:w-1/2 text-center lg:text-left mb-12 lg:mb-0">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight text-white mb-6">
              Manage All Your Crypto In One Secure Moon Wallet.
            </h1>
            <p className="text-xl text-gray-400 mb-10 max-w-lg lg:mx-0 mx-auto">
              The decentralized, non-custodial wallet with lightning-fast transactions and the industry's lowest fees.
            </p>
            <div className="flex flex-col sm:flex-row justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-4">
              <button 
                onClick={scrollToDownload}
                className="flex items-center justify-center px-8 py-3 bg-violet-400 text-gray-900 font-extrabold rounded-full hover:bg-violet-300 transition duration-300 shadow-xl shadow-violet-900/50 transform hover:scale-105"
              >
                <DownloadIcon className="w-5 h-5 mr-2" />
                Download Moon Wallet
              </button>
              <button className="flex items-center justify-center px-8 py-3 bg-gray-700 text-gray-200 font-semibold rounded-full hover:bg-gray-600 transition duration-300 shadow-lg shadow-gray-900/50">
                Explore Features
              </button>
            </div>
          </div>

          <div className="lg:w-1/2 flex justify-center relative">
            <div className="relative w-full max-w-lg h-auto rounded-3xl overflow-hidden shadow-[0_35px_60px_-15px_rgba(50,50,250,0.5)] transform rotate-3 scale-95 transition-all duration-500 hover:rotate-0 hover:scale-100 border border-blue-600/50">
              <img
                src={Wallet}
                alt="Moon Wallet Screenshot"
                className="w-full h-full object-contain object-center"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-900/30 to-black/0"></div>
    </section>
  );
};

const FeatureCard = ({ icon, title, description, color }) => (
  <div className="bg-gray-800/70 p-8 rounded-2xl border border-gray-700/50 shadow-2xl hover:border-blue-400/50 transition duration-500 transform hover:scale-[1.02]">
    {icon}
    <h3 className="text-2xl font-bold text-white mt-4 mb-2">{title}</h3>
    <p className="text-gray-400">{description}</p>
  </div>
);

const FeaturesSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-gray-900/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Moon Wallet Features</h2>
          <p className="text-gray-400 text-xl max-w-2xl mx-auto">
            A secure, non-custodial wallet solution built for speed and lunar transactions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <FeatureCard
            icon={<SecurityIcon className="w-10 h-10 text-blue-400" />}
            title="Decentralized Security"
            description="Your private keys are encrypted and never leave your device. Only you control your funds."
          />
          <FeatureCard
            icon={<ExchangeIcon className="w-10 h-10 text-violet-400" />}
            title="Instant Exchange"
            description="Swap instantly between over 500 crypto pairs with minimal latency and low fees."
          />
          <FeatureCard
            icon={<FeeIcon className="w-10 h-10 text-white" />}
            title="Lowest Transaction Fees"
            description="Enjoy market-leading low fees for all your transfers and transactions, maximizing your crypto."
          />
        </div>
      </div>
    </section>
  );
};

const DownloadSection = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = () => {
    setIsDownloading(true);
    
    // Replace with your actual APK file path
    const apkUrl = '/apk/moon-wallet.apk';
    
    // Create a temporary link to trigger download
    const link = document.createElement('a');
    link.href = apkUrl;
    link.download = 'moon-wallet.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setTimeout(() => setIsDownloading(false), 2000);
  };

  return (
    <section id="download-section" className="py-20 lg:py-32 bg-gray-900/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-white mb-6">
          Download Moon Wallet Now
        </h2>
        <p className="text-gray-400 text-xl mb-10 max-w-2xl mx-auto">
          Get started with the most secure crypto wallet. Available for Android devices.
        </p>
        
        <div className="bg-gray-800/50 p-8 rounded-2xl border border-gray-700/50 max-w-md mx-auto">
          <div className="flex items-center justify-center mb-6">
            <div className="bg-violet-400 p-3 rounded-full">
              <AndroidIcon className="w-8 h-8 text-gray-900" />
            </div>
          </div>
          
          <h3 className="text-2xl font-bold text-white mb-4">
            Android APK
          </h3>
          
          <p className="text-gray-400 mb-6">
            Version 1.0.0 • 77.2 MB
          </p>
          
          <button 
            onClick={handleDownload}
            disabled={isDownloading}
            className="w-full flex items-center justify-center px-6 py-4 bg-violet-400 text-gray-900 font-extrabold rounded-full hover:bg-violet-300 transition duration-300 shadow-xl shadow-violet-900/50 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isDownloading ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Downloading...
              </>
            ) : (
              <>
                <DownloadIcon className="w-5 h-5 mr-2" />
                Download APK
              </>
            )}
          </button>
          
          <p className="text-sm text-gray-500 mt-4">
            Requires Android 8.0 or later
          </p>
        </div>
        
        <div className="mt-8 bg-gray-800/30 p-6 rounded-xl border border-violet-400/20 max-w-2xl mx-auto">
          <h4 className="text-lg font-semibold text-violet-400 mb-3">Installation Instructions</h4>
          <ol className="text-gray-400 text-left text-sm space-y-2">
            <li>1. Download the APK file above</li>
            <li>2. Go to Settings → Security → Enable "Install from unknown sources"</li>
            <li>3. Open the downloaded APK file and tap "Install"</li>
            <li>4. Launch Moon Wallet and start managing your crypto!</li>
          </ol>
        </div>
        
        <div className="mt-8 text-gray-500">
          <p className="text-sm">
            By downloading, you agree to our <a href="#" className="text-violet-400 hover:underline">Terms of Service</a> and <a href="#" className="text-violet-400 hover:underline">Privacy Policy</a>
          </p>
        </div>
      </div>
    </section>
  );
};

const Footer = () => (
  <footer className="bg-gray-900 border-t border-blue-900/50 py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <div className="flex-shrink-0 flex items-center justify-center mb-6">
          <img 
            src={Logo}
            alt="Moon Wallet Logo" 
            className="h-8 w-auto mr-2" 
          />
          <span className="text-2xl font-extrabold text-white">
            <span className="text-white">Moon</span>
            <span className="text-violet-400">Wallet</span>
          </span>
        </div>
        <p className="text-gray-400 mb-6">
          The most secure and user-friendly crypto wallet
        </p>
        <div className="flex items-center justify-center mb-6">
          <a 
            href="mailto:info@moonwallet.io"
            className="flex items-center text-violet-400 hover:text-violet-300 transition-colors duration-200 text-lg font-semibold"
          >
            <EmailIcon className="w-5 h-5 mr-2" />
            info@moonwallet.io
          </a>
        </div>
        <div className="pt-8 border-t border-gray-800 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Moon Wallet. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
);

// Main App Component
const App = () => {
  return (
    <div className="min-h-screen bg-gray-950 font-sans antialiased">
      <script src="https://cdn.tailwindcss.com"></script>
      <style>
        {`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&display=swap');
        body {
            font-family: 'Inter', sans-serif;
            background: radial-gradient(circle at top, #111129 0%, #080718 100%);
        }
        ::-webkit-scrollbar {
            width: 8px;
        }
        ::-webkit-scrollbar-track {
            background: #1f1f3a;
        }
        ::-webkit-scrollbar-thumb {
            background: #5c629a;
            border-radius: 4px;
        }
        ::-webkit-scrollbar-thumb:hover {
            background: #7177a9;
        }
        `}
      </style>

      <PromotionBanner />
      <NavBar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <DownloadSection />
      </main>
      <Footer />
    </div>
  );
};

export default App;